import React from "react";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  isProcessing?: boolean;
  confirmBtnText?: string;
}

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  isProcessing,
  confirmBtnText,
}: ConfirmationModalProps) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // Close the modal only if clicking on the overlay
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center p-4 z-50 bg-black bg-opacity-50"
      onClick={handleOverlayClick}
    >
      <div
        className="bg-white w-full md:max-w-[450px] max-w-[380px] p-4 rounded-lg shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div>
          <h1 className="font-semibold xl:text-[20px] md:text-[19px] text-[18px] leading-[30px] mb-2 md:mb-4">
            {title}
          </h1>
          <h1 className="xl:text-[16px] md:text-[15px] text-[14px]">
            {message}
          </h1>
        </div>
        <div className="flex justify-end items-end md:gap-6 gap-4 mt-8">
          <button
            className="w-full rounded-[4px] md:h-[48px] h-[40px] xl:text-[16px] md:text-[15px] text-[14px] text-gray-700 font-semibold border border-gray-500"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="w-full rounded-[4px] md:h-[48px] h-[40px] xl:text-[16px] md:text-[15px] text-[14px] bg-[#D92D20] text-white font-semibold"
            onClick={onConfirm}
            disabled={isProcessing}
          >
            {confirmBtnText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
